import {
  Box,
  Center,
  SimpleGrid,
  Text
} from "@chakra-ui/react";
import CardScope from "./cardScope";
import SectionHeading from "./sectionHeading";
import LineSection from "../lineSection";
import Lang from "../../Lang";

export default function Scope() {
  return (
    <>
      <LineSection />

      <Box
        color='white'
        bg="black"
      >
        <Center>
          <Box
            w={{ base: "xl", md: "4xl", xl: "6xl" }}
            pt={20}
          >

            <SectionHeading
              title="Scope"
              align={"center"}
            />

            <Center
              mt={10}
            >

              <SimpleGrid
                columns={{ base: 1, md: 2, lg: 2, xl: 2 }}
                spacing={10}
                alignItems={"flex-start"}
              >
                <Box>
                  <CardScope
                    image="img/mature-asian-woman-entrepreneur-business-owner-standing-front-her-clay-ceramic-product-working-home.webp"
                    w={{ base: 300, md: 320, lg: 600 }}
                    h={{ base: 400, md: 500, lg: "385px" }}
                  />
                </Box>
                <Box
                  mt={{ xl: "200px" }}
                  display={{ base: "none", md: "flex" }}
                >
                  <CardScope
                    image="img/group-young-business-people-designers-they-working-new-project-startup-concept.webp"
                    w={{ base: 300, md: 320, lg: 600 }}
                    h={{ base: 400, md: 500, lg: "385px" }}
                  />
                </Box>

              </SimpleGrid>
            </Center>

            <Text
              pt={{ base: 10, md: 10, xl: 10 }}
              pb={{ base: 20, md: 15, xl: 40 }}
              px={{ base: 4, md: 6 }}
              fontSize={{ base: "1.3em", md: "1.5em", lg: "1.7", xl: "2em" }}
            >
              <Lang text="Our services are specifically aimed at social enterprises located in Colombia, those with annual revenues less than $200,000 USD, and fewer than 50 employees." />
            </Text>
          </Box>
        </Center>
      </Box>
    </>
  );
}